import { render, staticRenderFns } from "./ViewCustomerProjectBriefPopUp.vue?vue&type=template&id=bce6f794&scoped=true&"
import script from "./ViewCustomerProjectBriefPopUp.vue?vue&type=script&lang=js&"
export * from "./ViewCustomerProjectBriefPopUp.vue?vue&type=script&lang=js&"
import style0 from "./ViewCustomerProjectBriefPopUp.vue?vue&type=style&index=0&id=bce6f794&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bce6f794",
  null
  
)

export default component.exports